export default {
  buttonTitle: {
    en: 'Vaults explained',
    ru: 'Объяснение хранилищ',
    fr: 'Les coffres expliqués',
    es: 'Bóvedas explicadas',
    pt: 'Cofres explicados',
    de: 'Tresore erklärt',
    zh: 'Vaults已解释',
  },
}
